export interface OneInchGasResponse {
    baseFee: string;
    high: { maxPriorityFee: string; maxFeePerGas: string };
}
